// extracted by mini-css-extract-plugin
export default {"button":"Kh5HMz","flexContainer":"h7K_lu","count":"FYRNvd","switchCounterAndButton":"p9gct4","srOnly":"laz8E8"};